 module.exports = function(app) {
  'use strict';
  app
  	.directive('navigationTemplate', navigationTemplate);
  	navigationTemplate.$inject = [];
  	function navigationTemplate(){
  	return {
  		
  		template:require('./navbar.html')
  	}
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/navigation/navigationTemplate.js
// module id = 460
// module chunks = 0